module.exports = __webpack_public_path__ + "static/media/ic_proyecto_check_verde.09a0364a.svg";